import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-tech-logo',
  templateUrl: './tech-logo.component.html',
  styleUrls: ['./tech-logo.component.scss'],
})
export class TechLogoComponent {
  logoList = [
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/angular.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/angular.png',
      imageAlt: 'angular logo',
      imageType: 'png',
      imageClassName: 'angular',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/microsoft_dot_net.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/microsoft_dot_net.png',
      imageAlt: 'microsoft_dot_net logo',
      imageType: 'png',
      imageClassName: 'microsoft_dot_net',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/node.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/node.png',
      imageAlt: 'node logo',
      imageType: 'png',
      imageClassName: 'node',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/swift.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/swift.png',
      imageAlt: 'swift logo',
      imageType: 'png',
      imageClassName: 'swift',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/sqlServer.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/sqlServer.png',
      imageAlt: 'sqlServer logo',
      imageType: 'png',
      imageClassName: 'sqlServer',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/mySQL.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/mySQL.png',
      imageAlt: 'mySQL logo',
      imageType: 'png',
      imageClassName: 'mySQL',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/mongoDB.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/mongoDB.png',
      imageAlt: 'mongoDB logo',
      imageType: 'png',
      imageClassName: 'mongoDB',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/elastic.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/elastic.png',
      imageAlt: 'elastic logo',
      imageType: 'png',
      imageClassName: 'elastic',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/redis.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/redis.png',
      imageAlt: 'redis logo',
      imageType: 'png',
      imageClassName: 'redis',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/jenkin.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/jenkin.png',
      imageAlt: 'jenkin logo',
      imageType: 'png',
      imageClassName: 'jenkin',
    },
  ]

  constructor(public translate: TranslateService) {}

}
